/* import __COLOCATED_TEMPLATE__ from './switch-dynamically-button-group.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();